  <!-- Note: Do not use [disabled] on angular form controls
        check the method updateFormDisabledState() -->
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  
  <p-toolbar>
    <ng-template #start>
      <div class="flex gap-4 toolbar-menu" style="position: relative; z-index: 100;">
        <div class="flex flex-col">
          <label class="mr-2" for="gradeTypeFilter">Grade Type</label>
          <p-select
            id="gradeTypeFilter"
            [options]="gradeTypeOptions"
            [(ngModel)]="selectedType"
            [ngModelOptions]="{ standalone: true }"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            (onChange)="onTypeFilterChange($event.value)"
            class="w-44 relative z-[101]"
          ></p-select>
        </div>

         <div class="flex flex-col">
           <label class="mr-2" for="gradeNameFilter">Name Filter</label>
           <input id="gradeNameFilter" type="text" pInputText [value]="currentFilter" (input)="filterGrades(($any($event.target)).value)" placeholder="Search" class="relative z-[101]"/>
        </div>
        
        <app-scope-filter 
          [(selectedFilter)]="selectedScopeFilter"
          [userRoles]="userRoles()"
          (filterChange)="onScopeFilterChange()">
        </app-scope-filter>
      </div>
    </ng-template>
  </p-toolbar>

  @if (!isLoading()) {
  <form [formGroup]="gradesForm" novalidate autocomplete="off">  
    <ng-container formArrayName="grades">
      <p-table
        styleClass="p-datatable-sm pr-2"
        #catalogTable
        [appAutoTableHeight]="true"
        [appAutoTableHeightContainerSelector]="'.grid-stack-item-content'"
        [appAutoTableHeightOffset]="120"
        (appAutoTableHeightChange)="tableHeight.set($event)"
        [scrollable]="true"
        [scrollHeight]="tableHeight()"
        [paginator]="true"
        [first]="paginatorFirst()"
        (onPage)="onPageChange($event)"
        [rows]="rows"
        [rowsPerPageOptions]="[10, 15, 20, 25]"
        paginatorPosition="top"
        paginatorDropdownAppendTo="body"
        paginatorStyleClass="!py-1 !text-xs [&_button]:!min-w-7 [&_button]:!h-7 [&_.p-select]:!h-7 [&_.p-select-label]:!py-0 [&_.p-select-label]:!leading-7"
        [columns]="columnDefs" 
        [resizableColumns]="true"
        [value]="gradesCatalog.controls" 
        showGridlines
        dataKey="value.id" 
        stateStorage="local"
        [stateKey]="'gradesCatalogTable@' + componentId">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th class="text-sm text-center" style="width: 40px;"></th>
            @for (col of columns; track col.field) {
            <th pResizableColumn class="text-sm text-center">
              {{ col.header }}
            </th>
            }
            @if (userRoles()?.catalogAdmin) {
            <th class="text-sm text-center">Scope</th>
            }
            <th class="text-center">
              <div style="display: flex;">
                <p-button outlined="true" size="small" class="outlined-button" severity="success" icon="pi pi-plus"
                  (click)="onAddGrade()" title="Add Grade"></p-button>
                <p-button text size="small" severity="success" [disabled]="gradesCatalog.invalid" icon="pi pi-file-excel"
                (click)="exportExcel()" title="Export to Excel"></p-button>
              </div>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-gradeFg let-rIdx="rowIndex">
          <ng-container [formGroupName]="rIdx">
            <tr class="hover:bg-gray-500 transition-colors duration-100"
              [class.catalog-duplicate-row]="duplicateRowColors().has(gradeFg.get('id').value)"
              [style.background-color]="duplicateRowColors().get(gradeFg.get('id').value) ?? null">
              <td class="text-center">
                <app-catalog-metadata-icon [metadata]="gradeFg.value.metadata"></app-catalog-metadata-icon>
              </td>
              <td>
                <div
                  class="block"
                  (mouseenter)="setHoverTitle($event, !isControlInvalid(gradeFg, 'name') ? showJson(gradeFg.get('name').value) : getControlErrors(gradeFg, 'name'))"
                >
                  <input type="text" pInputText formControlName="name" autocomplete="off" />
                </div>
              </td>
              <td>
              <app-validated-number-input
                [id]="'minimumApiYieldStrength'"
                [control]="control(gradeFg, 'minimumApiYieldStrength')"
                [value]="control(gradeFg, 'minimumApiYieldStrength').value"
                [validation]="validationRules.minimumApiYieldStrength"
                [title]="'Allowed range: ' + validationRules.minimumApiYieldStrength.min + ' - ' + validationRules.minimumApiYieldStrength.max"
                [isGrid]="true"
              ></app-validated-number-input>
              </td>
              <td>
                <app-validated-number-input
                  [id]="'youngsModulus'"
                  [control]="control(gradeFg, 'youngsModulus')"
                  [value]="control(gradeFg, 'youngsModulus').value"
                  [validation]="validationRules.youngsModulus"
                  [title]="'Allowed range: ' + validationRules.youngsModulus.min + ' - ' + validationRules.youngsModulus.max"
                  [isGrid]="true"
                ></app-validated-number-input>
              </td>
              <td>
                <app-validated-number-input
                  [id]="'poissonsRatio'"
                  [control]="control(gradeFg, 'poissonsRatio')"
                  [value]="control(gradeFg, 'poissonsRatio').value"
                  [validation]="validationRules.poissonsRatio"
                  [isGrid]="true"
                  [title]="'Allowed range: 0 - 0.5'"
                ></app-validated-number-input>
              </td>
              <td>
                <app-validated-number-input
                  [id]="'thermalExpansionCoefficient'"
                  [control]="control(gradeFg, 'thermalExpansionCoefficient')"
                  [value]="control(gradeFg, 'thermalExpansionCoefficient').value"
                  [validation]="validationRules.thermalExpansionCoefficient"
                  [isGrid]="true"
                  [title]="'Allowed range: ' + validationRules.thermalExpansionCoefficient.min + ' - ' + validationRules.thermalExpansionCoefficient.max"
                ></app-validated-number-input>
              </td>
              <td>
                <app-validated-number-input
                  [id]="'ultimateTensileStrength'"
                  [control]="control(gradeFg, 'ultimateTensileStrength')"
                  [value]="control(gradeFg, 'ultimateTensileStrength').value"
                  [validation]="validationRules.ultimateTensileStrength"
                  [isGrid]="true"
                  [title]="'Allowed range: ' + validationRules.ultimateTensileStrength.min + ' - ' + validationRules.ultimateTensileStrength.max"
                ></app-validated-number-input>
              </td>
              <td>
                <app-validated-number-input
                  [id]="'density'"
                  [control]="control(gradeFg, 'density')"
                  [value]="control(gradeFg, 'density').value"
                  [validation]="validationRules.density"
                  [isGrid]="true"
                  [title]="'Allowed range: ' + validationRules.density.min + ' - ' + validationRules.density.max"
                ></app-validated-number-input>
              </td>
              <td>
                <app-validated-number-input
                  [id]="'specificHeatCapacity'"
                  [control]="control(gradeFg, 'specificHeatCapacity')"
                  [value]="control(gradeFg, 'specificHeatCapacity').value"
                  [validation]="validationRules.specificHeatCapacity"
                  [isGrid]="true"
                  [title]="'Allowed range: ' + validationRules.specificHeatCapacity.min + ' - ' + validationRules.specificHeatCapacity.max"
                ></app-validated-number-input>
              </td>
              <td>
                <app-validated-number-input
                  [id]="'thermalConductivity'"
                  [control]="control(gradeFg, 'thermalConductivity')"
                  [value]="control(gradeFg, 'thermalConductivity').value"
                  [validation]="validationRules.thermalConductivity"
                  [isGrid]="true"
                  [title]="'Allowed range: ' + validationRules.thermalConductivity.min + ' - ' + validationRules.thermalConductivity.max"
                ></app-validated-number-input>
              </td>
              <td class="text-center">
                <div
                  class="block"
                  (mouseenter)="setHoverTitle($event, showJson(gradeFg.get('temperatureDeration').value))"
                >
                  <p-select class="truncate-select" filter filterBy="label" resetFilterOnHide="true"
                    [placeholder]="getPlaceholderText(gradeFg.get('temperatureDeration').value)"
                    formControlName="temperatureDeration" [options]="temperatureDerations" appendTo="body">
                  </p-select>
                </div>
                <app-validation-error [isValid]="isControlInvalid(gradeFg, 'temperatureDeration')"
                  [errorMsg]="getControlErrors(gradeFg, 'temperatureDeration')"/>
              </td>
              <td class="text-center">
                <p-select
                  class="truncate-select"
                  title="Strength Calculation Option"
                  [placeholder]="getPlaceholderText(gradeFg.get('strengthCalculationOption').value)"
                  formControlName="strengthCalculationOption"
                  [options]="strengthCalculationOptions"
                  appendTo="body"
                  [title]="!isControlInvalid(gradeFg, 'strengthCalculationOption') ? 'Strength Calculation Option' : getControlErrors(gradeFg, 'strengthCalculationOption')"
                ></p-select>
              </td>
              @if (userRoles()?.catalogAdmin) {
              <td class="flex justify-center">
                @if (!gradeFg.get('isLocked').value) {
                <p-button
                  [label]="getScopeLabel(gradeFg.get('scope').value)"
                  [severity]="gradeFg.get('scope').value === CatalogScope.Global ? 'success' : 'info'"
                  size="small"
                  outlined="true"
                  class="outlined-button"
                  (click)="toggleScope(gradeFg)"
                  [title]="'Click to switch to ' + (gradeFg.get('scope').value === CatalogScope.User ? 'Global' : 'User')"
                ></p-button>
                } @else {
                <span class="text-sm text-gray-200">Global</span>
                }
              </td>
              }
              <td class="text-center">
                @if (!deleteGradeCheck(gradeFg)) {
                <i
                  title="Delete Grade"
                  class="pi pi-trash !text-red-400 cursor-pointer"
                  (click)="onDeleteGrade(rIdx)"
                ></i>
                } @else {
                <i
                  title="Locked catalog item, cannot be deleted."
                  class="pi pi-lock text-gray-400"
                ></i>
                }
              </td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </ng-container>
  </form>
  }
</app-tool-loader>